module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/71ecbef8269ffd9a54997de47aa7d9ee.png";